const MuiButton = {
  styleOverrides: {
    root: {
      textTransform: 'capitalize',
    }
  }
};

export default MuiButton;
